module.exports = __webpack_public_path__ + "img/m-close.b42f3191.svg";